import React from 'react';
import { useLocation } from 'react-router-dom';
import SchemaMarkup from './SchemaMarkup';
import { getSchemaMarkupForRoute } from '../utils/pageSchemas';

const RouteSchemaMarkup: React.FC = () => {
  const location = useLocation();
  const schema = getSchemaMarkupForRoute(location.pathname);
  
  return <SchemaMarkup schema={schema} />;
};

export default RouteSchemaMarkup;
